import Drawer from 'components/Drawer'
import { Form } from 'components/UIComponents/FormStyles'
import React from 'react'
import RequestConformDrawer from '../ConfirmDrawer/Partials/index'

const ConfirmDrawer = ({ form, conformDrawer, setConfirmDrawer }) => {
  const onClose = () => {
    setConfirmDrawer(false)
  }

  const content = () => {
    return (
      <Form scrollToFirstError id={'addUserForm'} form={form} layout="vertical">
        <RequestConformDrawer
          conformDrawer={conformDrawer}
          setConfirmDrawer={setConfirmDrawer}
        />
      </Form>
    )
  }

  return (
    <Drawer
      width="43%"
      title={'Bulk Upload'}
      placement="right"
      padding="30px"
      headerpadding="16px 30px"
      closable
      onClose={onClose}
      visible={conformDrawer}
      content={content()}
    />
  )
}

export default ConfirmDrawer
